import LandingLayout from "../layouts/LandingLayout";
import Content from "../Components/AiComponents/modules/solutions/Content";

function AboutChatbot() {
  return (
    <>
      <LandingLayout className="bg-black">
        <div className="w-full flex px-5 justify-between mt-16">
            <Content />
        </div>
      </LandingLayout>
    </>
  );
}

export default AboutChatbot;
